// src/components/common/ProtectedRoute.tsx
//--------------------------------------------------------------
import React, { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: ReactElement;
}

/**  Pages whose path contains this token can be viewed without auth */
const BYPASS_TOKEN = '123';

const ProtectedRoute = ({ children }: ProtectedRouteProps): ReactElement => {
  const { user, loading, isAnonymous } = useAuth();
  const location = useLocation();

  /* 1) let dev / QA paths like /dashboard123 skip the guard */
  const bypass = location.pathname.includes(BYPASS_TOKEN);

  /* 2) show loader while auth state resolves */
  if (loading) return <div>Loading...</div>;

  /* 3) skip all checks if it’s a bypass URL */
  if (bypass) return children;

  /* 4) normal production rules */
  if (!user)        return <Navigate to="/login" replace />;
  if (isAnonymous)  return <Navigate to="/"      replace />;

  /* 5) authenticated & not anonymous → allow */
  return children;
};

export default ProtectedRoute;
